<template>
<v-container>
  <toast v-model="toastText"></toast>
  <v-dialog v-model="dialog" hide-overlay persistent width="400" v-if="!loading && !isProcessing && !error && !success">
    <v-card>
      <v-card-text v-if="userId" class="text-xs-center mb-0">
        <v-avatar :size="64" class="mx-2 my-2"><img :src="userInfo.photoURL"></img></v-avatar>
        <p class="subheading font-weight-bold">{{userInfo.email}}</p>
      </v-card-text>
      <v-card-text>
        <p class="subheading">{{ $t('join.welcome') }}</p>
        <p v-if="userId" v-html="$t('join.welcome_description')"></p>
        <p v-if="!userId" v-html="$t('join.sign_in_required')"></p>
        <p v-if="!userId" v-html="$t('join.workaround_google_sign_in')"></p>
      </v-card-text>
      <v-card-actions>
        <v-btn large flat @click="copy" color="secondary">{{ $t('join.copy_link') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn large flat @click="login" color="primary" v-if="!userId">{{ $t('join.sign_in') }}</v-btn>
        <v-btn large flat @click="join" color="primary" v-if="userId">{{ $t('join.join_now') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <progress-dialog :visible="isProcessing">{{ $t('join.joining') }}</progress-dialog>

  <v-layout row justify-center class="my-5" v-if="error">
    <h3 class="grey--text">{{ error }}</h3>
  </v-layout>

  <v-layout row justify-center class="my-5" v-if="success">
    <h3 class="success--text">{{ success }}</h3>
  </v-layout>
</v-container>
</template>

<script>
import {
  UserAuth
} from 'luffanet-web-components'

export default {
  name: 'Client',
  mixins: [UserAuth],
  data: () => ({
    toastText: null,
    loading: true,
    md5: null,
    error: null,
    isProcessing: false,
    success: null,
    dialog: true
  }),
  methods: {
    onUserChanged() {
      let md5 = this.$route.params.clientId;
      if(!md5) {
        this.error = this.$t('join.invalid_auth');
      } else {
        this.md5 = md5;
      }
      this.loading = false;
    },
    login() {
      this.$router.replace('/login?redirect=' + encodeURIComponent(this.$route.fullPath));
    },
    async join() {
      this.isProcessing = true;
      let ref = this.$db.ref('clientAuth').child(this.userId);
      await ref.remove();
      await ref.set(this.md5);
      ref.on('value', async (snapshot) => {
        let val = snapshot.val();
        if(val === this.md5) {
          return;
        } else if(val === 'invalid') {
          await snapshot.ref.off();
          await snapshot.ref.remove();
          this.error = this.$t('join.invalid_auth');
        } else {
          await snapshot.ref.off();
          await snapshot.ref.remove();
          this.success = this.$t('join.join_success');
        }
        this.isProcessing = false;
      });
    },
    async copy() {
      try {
        await this.$copyText(window.location.href);
        this.toastText = this.$t('join.link_copied');
      } catch (err) {
        console.log(err);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/join.vue